import {CreateInstance} from './config'
const remoteAPI = CreateInstance('remoteControl')
export default remoteAPI
